import type { Board } from '@atlassian/jira-boards-common/src/model/index.tsx';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'directories.boards-v2.main.flags.delete.success.title',
		defaultMessage: '{boardName} deleted',
		description: 'Title of the flag that gets shown when a board is successfully deleted.',
	},
	titlePrivateBoard: {
		id: 'directories.boards-v2.main.flags.delete.success.title-private-board',
		defaultMessage: 'Board deleted',
		description: 'Title of the flag that gets shown when a private board is successfully deleted.',
	},
});

const deleted = (board: Board) => {
	// @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
	if (board.isPrivate) {
		return { type: 'success', title: messages.titlePrivateBoard };
	}
	// @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
	return { type: 'success', title: [messages.title, { boardName: board.name }] };
};

export default deleted;
